import BeCuponUtils from "@/utils/Utils";

export default class Deal {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        dealRetrieve(id: ${id}) {
          id
          name
          description
          dateStart
          dateOff
          totalCoupon
          totalCouponFree
          totalCouponWelcome
          totalCouponReference
          totalCouponReferer
          couponWelcomeCopiesAvailable
          couponReferenceCopiesAvailable
          couponRefererCopiesAvailable
          couponWelcomeAvailableForEditList {
            id
            title
          }
          file {
            id
            url
          }
          company {
            id 
            name
            description
          }
          services {
            id 
            name
            description
            price
          }          
          couponFreeList {
            isActive
            available
            amountCompleted
            amountActives
            id
            title
            subTitle
            description
            smallDescription
            expirationDate
            globalTotalUses
            globalUses
            globalActives
            images {
              id
              url
            }
            initialDate
            dailyUses
            totalUses
            maxPerson
            valuedAt
            coupons {
              id
              title
              maximumSales
            }            
          }          
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    response.data.data.dealRetrieve.totalCouponAssigned = BeCuponUtils.getTotalCouponAssigned(response.data.data.dealRetrieve.couponFreeList);
    response.data.data.dealRetrieve.totalServices = response.data.data.dealRetrieve.services.length;
    response.data.data.dealRetrieve.totalPayment = BeCuponUtils.getTotalPaymentServices(response.data.data.dealRetrieve.services);

    response.data.data.dealRetrieve.totalCouponFree = response.data.data.dealRetrieve.totalCouponFree !== null ? response.data.data.dealRetrieve.totalCouponFree : response.data.data.dealRetrieve.totalCoupon;
    response.data.data.dealRetrieve.totalCouponWelcome = response.data.data.dealRetrieve.totalCouponWelcome !== null ? response.data.data.dealRetrieve.totalCouponWelcome : 0;
    response.data.data.dealRetrieve.totalCouponReference = response.data.data.dealRetrieve.totalCouponReference !== null ? response.data.data.dealRetrieve.totalCouponReference : 0;
    response.data.data.dealRetrieve.totalCouponReferer = response.data.data.dealRetrieve.totalCouponReferer !== null ? response.data.data.dealRetrieve.totalCouponReferer : 0;

    for(var i=0; i < response.data.data.dealRetrieve.couponFreeList.length; i++) {
      if(response.data.data.dealRetrieve.couponFreeList[i].coupons !== null) {
          response.data.data.dealRetrieve.couponFreeList[i].globalUses = response.data.data.dealRetrieve.couponFreeList[i].totalUses * response.data.data.dealRetrieve.couponFreeList[i].coupons.maximumSales;
      }
    }

    return response.data.data.dealRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        dealList(pageSize:1000000000) {
          results {
            id
            name
            description
            dateStart
            dateOff
            totalCoupon
            totalCouponFree
            totalCouponWelcome
            totalCouponReference
            totalCouponReferer 
            couponWelcomeCopiesAvailable
            couponReferenceCopiesAvailable
            couponRefererCopiesAvailable                       
            file {
              id
              url
            }            
            company {
              id 
              name
              description
            }
            services {
              id 
              name
              description
              price
            }            
            couponFreeList {
              totalUses
              coupons {
                maximumSales
              }            
            }            
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    for(var i=0; i < response.data.data.dealList.results.length; i++) {
      response.data.data.dealList.results[i].totalCouponAssigned = BeCuponUtils.getTotalCouponAssigned(response.data.data.dealList.results[i].couponFreeList);
      response.data.data.dealList.results[i].totalCouponFree = response.data.data.dealList.results[i].totalCouponFree !== null ? response.data.data.dealList.results[i].totalCouponFree : response.data.data.dealList.results[i].totalCoupon;
      response.data.data.dealList.results[i].totalServices = response.data.data.dealList.results[i].services.length;
      response.data.data.dealList.results[i].totalPayment = BeCuponUtils.thousands(
        BeCuponUtils.getTotalPaymentServices(response.data.data.dealList.results[i].services)
      );
    }

    return response.data.data.dealList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteDeal(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteDeal.ok;
  }

  static async create(axios, name, description, dateStart, dateOff, totalCoupon, totalCouponWelcome,
                      totalCouponReference, totalCouponReferer, totalCouponFree, company, services) {
    const newDescrip = description.replace(/(\r\n|\n|\r)/gm, "");
    const desc = newDescrip !== null ? `description: "${newDescrip}",`: ``;
    const serv = services.length !== 0 ? `services: ${JSON.stringify(services)}`: ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        createDeal(newDeal: {
          name: "${name}", 
          ${desc}
          dateStart: "${dateStart}",
          dateOff: "${dateOff}", 
          totalCoupon: ${totalCoupon},
          totalCouponFree: ${totalCouponFree},
          totalCouponWelcome: ${totalCouponWelcome},
          totalCouponReference: ${totalCouponReference},
          totalCouponReferer: ${totalCouponReferer},
          company: ${company},
          ${serv}
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createDeal.ok;
  }


  static async edit(axios, id, name, description, dateStart, dateOff, totalCoupon, totalCouponWelcome,
                    totalCouponReference, totalCouponReferer, totalCouponFree, company, services) {
    const newDescrip = description.replace(/(\r\n|\n|\r)/gm, "");

    const desc = newDescrip !== null ? `description: "${newDescrip}",`: ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateDeal(newDeal: {
          id: ${id},
          name: "${name}", 
          ${desc}
          dateStart: "${dateStart}",
          dateOff: "${dateOff}", 
          totalCoupon: ${totalCoupon},
          totalCouponFree: ${totalCouponFree},
          totalCouponWelcome: ${totalCouponWelcome},
          totalCouponReference: ${totalCouponReference},
          totalCouponReferer: ${totalCouponReferer},          
          company: ${company},
          services: ${JSON.stringify(services)}
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateDeal.ok;
  }

}
